import { render, staticRenderFns } from "./Who5Modal.vue?vue&type=template&id=8b23f9c8"
import script from "./Who5Modal.vue?vue&type=script&lang=js"
export * from "./Who5Modal.vue?vue&type=script&lang=js"
import style0 from "./Who5Modal.vue?vue&type=style&index=0&id=8b23f9c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports